import { useI18n } from '../../../shared/i18n/I18nProvider';
import { ReadOnlyModal } from '../../../shared/ui/WorkspaceKit';

export function ExpenseForm({ onClose }: { onClose: () => void; onDone: (date: string) => void; embedded?: boolean }) {
  const { t } = useI18n();
  return <ReadOnlyModal feature={t('Thêm khoản chi')} onClose={onClose} />;
}
